import { render } from "./ImageModal.vue?vue&type=template&id=6acbfa17&scoped=true&ts=true"
import script from "./ImageModal.vue?vue&type=script&lang=ts"
export * from "./ImageModal.vue?vue&type=script&lang=ts"

import "./ImageModal.vue?vue&type=style&index=0&id=6acbfa17&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6acbfa17"]])

export default __exports__